import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import type { ProductsSearchQuery } from '@/http/zamply/products/search-products-schema'
import { fetchProduct, fetchProductsCatalog } from './fetchers'
import { productsKeys } from './query-keys'

export function productsCatalogQueryOptions(query: ProductsSearchQuery) {
  return queryOptions({
    queryKey: productsKeys.catalog(query),
    queryFn: ({ signal }) => fetchProductsCatalog(query, signal),
    // Mantém paginação/contagem na tela enquanto a nova página carrega.
    placeholderData: keepPreviousData,
  })
}

export function productQueryOptions(reference: string) {
  return queryOptions({
    queryKey: productsKeys.detail(reference),
    queryFn: () => fetchProduct(reference),
  })
}
